module.exports = __webpack_public_path__ + "img/pub12.1458dd8d.png";